import React from "react";
import styles from "./CivilLaw.module.css";
import CustomTitle from "../components/CustomTitle";
//import LocationFooter from "./LocationFooter";
const FamilyLaw = () => {
  return (
    <>
      <section className={styles.practiceAreas}>
        <CustomTitle>Family Law</CustomTitle>

        <div className={styles.practiceList}>
          <div className={styles.practiceCard}>
            <p>
              Our family law practice is centered around sensitivity,
              confidentiality, and a results-oriented approach. We assist
              clients in matrimonial disputes, divorce, child custody,
              maintenance, adoption, and inheritance matters. Our lawyers
              provide both litigation support and mediation services,
              recognizing the personal nature of family disputes. With
              compassion and professionalism, we strive to resolve matters in a
              manner that preserves dignity while safeguarding legal rights.
            </p>
            <ul>
              <li>Matrimonial disputes & divorce.</li>
              <li>Child custody & guardianship.</li>
              <li>Inheritance and succession.</li>
              <li>Assault, theft, and homicide.</li>
            </ul>
          </div>
        </div>
      </section>
      {/*  <LocationFooter /> */}
    </>
  );
};

export default FamilyLaw;
